import {
  Stack,
  styled,
  Typography,
  AvatarGroup as MuiAvatarGroup,
  Box,
  alpha
} from '@mui/material';

import palette from '../../theme/palette';

const BORDER_RADIUS = '8px';

export const CardContainer = styled(Stack)({
  position: 'relative',
  borderRadius: BORDER_RADIUS,
  minWidth: '196px',
  maxWidth: '196px',
  height: '201px',
  border: `1px solid ${palette.grey[1200]}`,
  ':hover': {
    cursor: 'pointer',
    boxShadow: '0px 6px 8px -6px rgba(24, 39, 75, 0.12),0px 8px 16px -6px rgba(24, 39, 75, 0.08)'
  }
});

export const BorderLayer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: BORDER_RADIUS,
  background: `linear-gradient(47deg, #366EE9 0%, #AF83F9 36.54%, #715DE6 66.83%, #7E4CDC 100%)`
});

export const ContentLayer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isChecked'
})<{ isChecked: boolean }>(({ isChecked }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  padding: '0px',
  ...(isChecked && {
    padding: '2px'
  })
}));

export const ContentWithBackground = styled(Box)({
  width: '100%',
  height: '100%',
  backgroundColor: palette.white,
  borderRadius: `calc(${BORDER_RADIUS} - 1px)`,
  overflow: 'hidden'
});

export const MeetingTitle = styled(Typography)({
  fontSize: '13px',
  color: palette.black,
  minHeight: '25px',
  marginBottom: '6px',
  fontWeight: 600
});
export const SummaryHover = styled(Typography)({
  fontSize: '12px',
  color: palette.grey[500],
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '64px',
  padding: '4px',
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: palette.grey[1200]
  }
});

export const AvatarGroup = styled(MuiAvatarGroup)({
  '& .MuiAvatar-root': {
    width: '20px !important',
    height: '20px !important',
    fontSize: '10px !important',
    background: palette.grey[900],
    color: palette.grey[500]
  }
});

export const ImageBox = styled(Box)({
  position: 'relative',
  minHeight: '110px',
  maxHeight: '110px',
  overflow: 'hidden'
});

export const ImageTopLayer = styled(Box)({
  position: 'absolute',
  zIndex: 1,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: alpha(palette.purple[300], 0.1)
});